<template>
  <div id="chart">
    <apexchart
      type="bar"
      height="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  props: ["title", "data", "categories", "colors"],
  data: () => ({
    series: [],
  }),

  watch: {
    data() {
      this.render();
    },
  },

  computed: {
    options() {
      return {
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.emitirEventoParaAbrirDialog(config);
            },
            dataPointMouseEnter: function(event, chartContext, config) {
              document.body.style.cursor = 'pointer';
            },
            dataPointMouseLeave: function(event, chartContext, config) {
              document.body.style.cursor = '';
            }
          },
        },
        grid: {
          yaxis: {
            lines: {
              show: true,
            },
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
          padding: {
            top: -10,
            left: 0,
            right: 0,
            bottom: 0,
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: false,
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return new Intl.NumberFormat("pt-BR", {
              style: "decimal",
              maxDigits: 4,
            }).format(val);
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: [],
          },
        },
        colors: [],
        legend: {
          show: true,
          position: "top",
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        title: {
          text: "",
        },
        tooltip: {
          enabled: false,
        }
      };
    },
  },

  created() {
    this.render();
  },

  methods: {
    emitirEventoParaAbrirDialog(config) {
      const chart = {
        categorie: config.dataPointIndex,
        ativar_filtro_comprador: config.seriesIndex !== 0,
      };

      this.$emit("dataPointIndex", chart);
    },

    render() {
      this.options.colors = [];
      this.series = [];

      Object.values(this.data).forEach((item) => {
        this.series.push({
          name: item.title,
          data: item,
        });
      });

      this.updateInfoGrafico();
    },

    updateInfoGrafico() {
      this.options.xaxis = {
        categories: this.categories,
      };

      this.options.colors = this.colors;

      this.options.title = {
        text: this.title,
      };
    },
  },
};
</script>
